module.exports = __webpack_public_path__ + "img/inspiration-6@2x.e00d376.jpg";